import styled from 'styled-components'
import { Col, Row } from 'react-styled-flexboxgrid'
import variables from '../../styles/variables'
import { Heading } from '..'
import { headerStyles } from '../../styles/global'
import plusPattern from '../../../assets/plus-pattern.svg'
import { TextWrapper } from '../../styles/base'

export const WhyAitoContainer = styled.div`
  width: 100%;
  background-image: url(${plusPattern});
  margin-top: 60px;
  
  @media ${variables.media.md} {
    margin-top: 0;
  }
`

export const SectionContainer = styled(TextWrapper)`
  color: ${variables.colors.oracle.dark};
`

export const WhyAitoHeader = styled(Heading)`
  ${headerStyles.headerSmall};
  font-weight: normal;
  margin-bottom: 20px;
  @media ${variables.media.sm} {
    margin-bottom: 50px;
  }
`
export const WhyAitoSmallHeader = styled(Heading)`
  ${headerStyles.headerXXSmall};
  color: ${variables.colors.eunry.dark};
  margin: 40px 0 10px 0;
`
export const WhyAitoText = styled.p`
  margin-bottom: 50px;
`
export const WhyAitoRow = styled(Row)`
  width: 100%;
`
export const WhyAitoCol = styled(Col)`
  position: relative;
`
export const WhyAitoSquare = styled.img`
  visibility: hidden;
  height: 0;

  @media ${variables.media.md} {
    visibility: visible;
    position: absolute;
    left: 50px;
    height: 150px;
    width: 150px;
    transform: rotate(45deg);
  }
`

export const WhyAitoAnimation = styled.div`
  display: none;
  
  @media ${variables.media.sm} {
    display: block;
    max-width: 300px;
  }
`
